/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderStatus {
    Created = 0,
    Paid = 1,
    Delivered = 2,
}